// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime elements
import { TableRow, TableCell } from '@/components/_primes'

// Partial Components
import { NormalTableHeader, SortableTableHeader, SelectableTableHeader } from './partial'

import { GREY_COLOR } from '@/styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
import { TableHeaderPartialProps, SelectableTablePartialProps } from '../TableContainer'

export interface TableHeaderBaseFCProps extends TableHeaderPartialProps, SelectableTablePartialProps {
    isSortable?: boolean
    isSelectable?: boolean
}
interface TableHeaderFCProps extends TableHeaderBaseFCProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const TableHeader = (props: TableHeaderFCProps) => {
    const {
        isSortable,
        isSelectable,
        onSelectAllChange,
        selectedNum,
        rowsNum,
        isAllSelected,
        defaultRowWidth,
        onSelectAllClick,
        ...other
    } = props
    const backgroundColor = { backgroundColor: GREY_COLOR }
    const tableHeaderFirstCell = isSelectable ? (
        <SelectableTableHeader
            onSelectAllChange={onSelectAllChange}
            onSelectAllClick={onSelectAllClick}
            selectedNum={selectedNum}
            rowsNum={rowsNum}
            isAllSelected={isAllSelected}
            defaultRowWidth={defaultRowWidth}
        />
    ) : (
        <TableCell style={{ width: 12, padding: 0 }} />
    )

    // ! Index Header Cell
    // <TableCell colSpan={1}>No</TableCell>

    const tableHeaderRestCells = isSortable ? <SortableTableHeader {...other} /> : <NormalTableHeader {...other} />

    return (
        <TableRow style={backgroundColor}>
            {tableHeaderFirstCell}
            {tableHeaderRestCells}
        </TableRow>
    )
}

export default TableHeader
